module.exports = __webpack_public_path__ + "static/media/pencil.428ca2ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pencil.svg
// module id = 101
// module chunks = 0